import { render, staticRenderFns } from "./InfoNavigation.vue?vue&type=template&id=e721bfe4&"
import script from "./InfoNavigation.vue?vue&type=script&lang=js&"
export * from "./InfoNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports